import React from 'react';

import { useConfig, useContractContext, useStrings } from 'src/providers';
import { useCurrencyFormatter } from 'src/hooks/useCurrencyFormatter';

import { FormattedString } from 'src/components/Shared/FormattedString';
import { StyledSimpleButton, StyledSimpleContainer } from './StyledSimple';

import { ReactComponent as ShieldLogo } from 'src/images/logos/logo-shield.svg';
import { ReactComponent as ShieldLogoXCover } from 'src/images/logos/logo-shield-xcover.svg';

interface ISimpleProps {
  onClick: () => void;
}

export function Simple(props: ISimpleProps) {
  const formatCurrency = useCurrencyFormatter();
  const { showXCoverBranding } = useConfig();
  const { simpleButtonText } = useStrings();
  const { startingAtPrice } = useContractContext();
  const { onClick } = props;

  return (
    <StyledSimpleContainer useSmallTextSize>
      <StyledSimpleButton
        data-test="product-page-simple"
        id="simple"
        onClick={onClick}
        type="button"
      >
        <span className="logo">
          {showXCoverBranding
            ? <ShieldLogoXCover data-test="clyde-logo-simple"/>
            : <ShieldLogo data-test="clyde-logo-simple"/>
          }
        </span>

        <FormattedString
          className="prompt"
          string={simpleButtonText}
          tagName="span"
          values={{ price: formatCurrency(startingAtPrice) }}
        />
      </StyledSimpleButton>
    </StyledSimpleContainer>
  );
}
